const AV = require('./core');
const useAdatpers = require('./use-adapters');

module.exports = useAdatpers(AV);



// WEBPACK FOOTER //
// ./src/entry/index.js